import { render, staticRenderFns } from "./TemplateInfo.vue?vue&type=template&id=3b647c34&"
import script from "./TemplateInfo.vue?vue&type=script&lang=js&"
export * from "./TemplateInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports